import React from "react";

export default function ResearchContributionChoice({ checked, onChange, available = true, disabled = false }) {
    return <label className="research-contribution-choice">
        <input type="checkbox" checked={available && checked} disabled={!available || disabled}
            onChange={event => onChange(event.target.checked)} />
        <span>
            Also contribute this reviewed turn to the moderated research queue (off by default).
            <small>{available
                ? "Optional. You can continue playing without contributing. Recording storage is separately controlled."
                : "Research contribution is unavailable for this input type. Review Data & consent to opt in; you can still play without contributing."}</small>
        </span>
    </label>;
}
